import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import React, { useState, useCallback, useEffect, useContext } from "react";
import "../index.css";
import { useNavigate, useLocation } from "react-router-dom";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIosNew";
import axios from 'axios';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { FaTag } from 'react-icons/fa';
import { ProductContext } from "../context/AppContext";
import { Card, Grid, Typography } from '@mui/material';
import FooterNav from "./Common_Components/FooterNav";
import translations from "./translation";

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

function LearningJourney() {
    const navigate = useNavigate();
    const location = useLocation();
    const { Leveldata, ExamTypedata, Universitydata, DaysLeft, marker, setMarker, Translate } = useContext(ProductContext);
    const selectedLanguage = localStorage.getItem("selectedLanguage") || "hindi";
    const localTranslations = translations[selectedLanguage === "hindi" ? "hindi" : "english"];
    console.log("DaysLeft:", DaysLeft);
    console.log("Universitydata: ExamTypedata: Leveldata", Leveldata, ExamTypedata, Universitydata);
    const [value, setValue] = useState(0);
    const [inputValue, setInputValue] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [examId, setExamId] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedModule, setSelectedModule] = useState(null);
    const [isCouponModalOpen, setIsCouponModalOpen] = useState(false);
    const [couponCode, setCouponCode] = useState("");
    const authToken = localStorage.getItem("AuthToken");
    const [isModalVisible, setModalVisible] = useState(false);
    const [universityData, setUniversityData] = useState([]);
    const [hasSubscribed, setHasSubscribed] = useState(false);
    const [couponVerified, setCouponVerified] = useState(false);
    const [learningnData, setLearningData] = useState([]);
    const [activeItem, setActiveItem] = useState(null);
    const [activeItemName, setActiveItemName] = useState("");
    const [levels, setLevels] = useState([]);
    const [lastDay, setLastDay] = useState("");
    const [selectedUniversity, setSelectedUniversity] = useState("");
    const [selectedLevel, setSelectedLevel] = useState("");
    const [isNoData, setIsNoData] = useState(false);
    const [isLoadingImage, setIsLoadingImage] = useState(true);
    const [subscriptionDaysLeft, setSubscriptionDaysLeft] = useState(0);

    const HomeScreenData = location.state;
    const initialExamId = HomeScreenData?.examId;
    // const examTypes = HomeScreenData?.examTypes || [];
    const { examTypes } = useContext(ProductContext);
    const selectedExamType = HomeScreenData?.selectedExamType;
    const selectedExamId_New = HomeScreenData?.selectedExamId_New;
    console.log("selectedExamId_New:", selectedExamId_New);
    const exams = Array?.isArray(examTypes) ? examTypes : [];

    console.log(exams, "exams Learn data")
    console.log(examTypes,"examTypes Laern")
    console.log("Home Screen Data:", initialExamId, examTypes);

    const [selectedExamId, setSelectedExamId] = useState(null);
    const [activeExamId, setActiveExamId] = useState(null);

    // Attendance data (static for now, replace with API if available)
    const attendanceData = [
        { name: "Present", value: 1, color: "#10B981" },
        { name: "Absent", value: 0, color: "#EF4444" },
        { name: "Leave", value: 0, color: "#F59E0B" },
        { name: "Not Marked", value: 25, color: "#6B7280" },
    ];
    const hasValidData = attendanceData.some((entry) => entry.value > 0);

    // Initialize selectedExamId
    useEffect(() => {
        const initializeExamId = async () => {
            const stateExamId = location.state?.selectedExamId;
            const stateExamType = location.state?.selectedExamType;
            const matchedStateExamType = stateExamType
                ? exams.find((exam) => String(exam?.exam_type).toLowerCase() === String(stateExamType).toLowerCase())
                : null;

            let resolvedExamId = null;
            let resolvedExamType = null;

            if (matchedStateExamType) {
                resolvedExamId = parseInt(matchedStateExamType.exam_id, 10);
                resolvedExamType = matchedStateExamType.exam_type;
            } else if (stateExamId) {
                resolvedExamId = parseInt(stateExamId, 10);
            } else {
                // No explicit exam ID in state. Fetch latest visited status.
                let latestVisitExamId = null;
                if (authToken) {
                    setIsLoading(true);
                    try {
                        const response = await axios.get(
                            `https://api.japaking.online/api/user-visits/latest-visited-status`,
                            {
                                headers: {
                                    Authorization: `Bearer ${authToken}`,
                                    "Content-Type": "application/json",
                                },
                            }
                        );
                        const latestVisit = response?.data || null;
                        if (latestVisit) {
                            latestVisitExamId = Number(
                                latestVisit.exam_id ||
                                latestVisit.lessonDetails?.exam_id ||
                                latestVisit.learningMethodDetails?.exam_id
                            );
                        }
                    } catch (error) {
                        console.error("Error fetching latest visited status in LearningJourney:", error);
                    } finally {
                        setIsLoading(false);
                    }
                }

                // If latestVisitExamId is valid and exists in exams, use it
                const matchedLatestExam = latestVisitExamId
                    ? exams.find((exam) => Number(exam.exam_id) === Number(latestVisitExamId))
                    : null;

                if (matchedLatestExam) {
                    resolvedExamId = Number(matchedLatestExam.exam_id);
                    resolvedExamType = matchedLatestExam.exam_type;
                } else {
                    // Fallback to storedExamId
                    const storedExamId = localStorage.getItem("selectedExamId");
                    if (storedExamId) {
                        resolvedExamId = parseInt(storedExamId, 10);
                    } else if (exams.length > 0) {
                        resolvedExamId = exams[0].exam_id;
                        resolvedExamType = exams[0].exam_type;
                    }
                }
            }

            if (resolvedExamId) {
                setSelectedExamId(resolvedExamId);
                setActiveExamId(resolvedExamId);
                setValue(resolvedExamId);
                localStorage.setItem("selectedExamId", resolvedExamId);
                if (resolvedExamType) {
                    localStorage.setItem("selectedExamType", resolvedExamType);
                }
            }
        };

        if (exams && exams.length > 0) {
            initializeExamId();
        }
    }, [exams, location.state, authToken]);

    // Cleanup localStorage on unmount (optional)
    useEffect(() => {
        return () => {
            // Optionally clear stored tab ID
            // localStorage.removeItem("selectedExamId");
        };
    }, []);

    const ConvertExamID = selectedExamId || selectedExamId_New;
    console.log("ConvertExamID:", ConvertExamID);

    useEffect(() => {
        if (ConvertExamID) {
            getQuizTypeDetails(ConvertExamID);
        }
    }, [ConvertExamID]);

    const getQuizTypeDetails = async (currentExamId) => {
        try {
            setIsLoading(true);
            const response = await axios.get(
                `https://api.japaking.online/api/exam-types/days/${currentExamId}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${authToken}`,
                    },
                }
            );

            if (response.data.success) {
                const days = response?.data?.message?.days;
                if (days && days.length > 0) {
                    setLearningData(days);
                    const lastDayId = days[days.length - 1].id;
                    setLastDay(lastDayId);
                    setIsNoData(false);
                    localStorage.setItem("LearningDataLocal", JSON.stringify(days));
                } else {
                    setLearningData([]);
                    setIsNoData(true);
                    console.log("No days data found");
                    navigate("/coming-soon", {
                        state: {
                            examTypes,
                            selectedExamId,
                            selectedExamType,
                        },
                    });
                    localStorage.removeItem("LearningDataLocal");
                }
            } else {
                setLearningData([]);
                setIsNoData(true);
                console.log("Failed to fetch data");
                localStorage.removeItem("LearningDataLocal");
            }
        } catch (error) {
            setLearningData([]);
            setIsNoData(true);
            console.error("Error getting the quiz type:", error);
            localStorage.removeItem("LearningDataLocal");
        } finally {
            setIsLoading(false);
        }
    };

    const handleExamTypeClick = (event, newValue) => {
        const examIdAsInt = parseInt(newValue, 10);
        if (isNaN(examIdAsInt)) {
            console.error("Invalid exam ID:", newValue);
            return;
        }

        setExamId(examIdAsInt);
        setActiveExamId(examIdAsInt);
        setSelectedExamId(examIdAsInt);
        setValue(examIdAsInt);
        localStorage.setItem("selectedExamId", examIdAsInt);

        Promise.all([
            getDayMarker(examIdAsInt),
            getQuizTypeDetails(examIdAsInt)
        ]).catch(error => console.error("Error loading data:", error));
    };

    const handleCardPress = (day_id, day_name, pono) => {
        setActiveItem(day_id);
        setActiveItemName(day_name);
        localStorage.setItem("ModuleId", day_id);
        localStorage.setItem("ModuleNameName", day_name);
        localStorage.setItem("examId", activeExamId);
        // Save active module so we can restore highlight/position when coming back
        try {
            localStorage.setItem("LearningJourneyActiveModuleId", String(day_id));
            localStorage.setItem("LearningJourneyActiveModuleName", day_name);
        } catch (e) {
            console.error("Error saving LearningJourney active module:", e);
        }
        const couponVerifiedLocal = localStorage.getItem("couponVerified") === "true";
        if (
            day_name === "Lesson 0" || day_name === "पाठ 0" ||
            day_name === "Lesson 1" || day_name === "पाठ 1" ||
            (hasSubscribed || couponVerifiedLocal)
        ) {
            navigate("/day-module", {
                state: {
                    ModuleId: day_id,
                    unique_day_id: day_id,
                    ModuleNameName: day_name,
                    Day_Name: day_name,
                    examId: activeExamId,
                    examTypes,
                    selectedExamId: selectedExamId, // Pass selectedExamId
                    exams,
                },
            });
        } else {
            setIsModalOpen(true);
        }
    };

    const getDayMarker = useCallback(
        async (examId) => {
            try {
                const response = await fetch(
                    `https://api.japaking.online/api/user-visits/visited-status?examId=${examId}`,
                    {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${authToken}`,
                        },
                    }
                );

                if (!response.ok) {
                    throw new Error(`HTTP error: ${response.status}`);
                }

                const data = await response.json();
                const idArray = data.map((item) => item.id).filter((id) => id !== null);
                const uniqueIdArray = [...new Set(idArray)];
                console.log("Filtered array:", uniqueIdArray);
                setMarker(uniqueIdArray);
            } catch (error) {
                console.error("Error getting marker IDs:", error);
            }
        },
        [authToken, setMarker]
    );

    useEffect(() => {
        if (selectedExamId) {
            getDayMarker(selectedExamId);
        }
    }, [selectedExamId, getDayMarker]);

    const closeModal = () => {
        setIsModalOpen(false);
        setIsCouponModalOpen(false);
    };

    const openCouponModal = () => {
        setIsCouponModalOpen(true);
    };

    const verifyCoupon = useCallback(async () => {
        try {
            const url = `https://api.japaking.online/api/coupon/subscribe`;
            const requestBody = {
                couponCode: couponCode.trim(),
                college_name: selectedUniversity,
                exam_type: selectedLevel,
            };

            const response = await fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${authToken}`,
                },
                body: JSON.stringify(requestBody),
            });

            const result = await response.json();

            if (response.ok && result.message.success) {
                setCouponVerified(true);
                localStorage.setItem('couponVerified', 'true');
                alert("Coupon Applied Successfully!");
                setIsModalOpen(false);
                setIsCouponModalOpen(false);
                await checkSubscription();
                localStorage.setItem("ModuleId", activeItem);
localStorage.setItem("examId", activeExamId);

                navigate("/day-module", {
                state: {
                        ModuleId: activeItem,
                        unique_day_id: activeItem,
                        ModuleNameName: activeItemName,
                        examId: activeExamId,
                        examTypes,
                        selectedExamId,
                    },
                });
            } else {
                console.error("Coupon verification failed:", result);
                alert("Incorrect Coupon Code or Exam Type");
            }
        } catch (error) {
            console.error("Error verifying coupon:", error);
        }
    }, [
        couponCode,
        selectedUniversity,
        selectedLevel,
        authToken,
        activeItem,
        activeItemName,
        navigate,
        activeExamId,
        examTypes,
        selectedExamId
    ]);

    const checkSubscription = useCallback(async () => {
        try {
            setIsLoading(true);
            const response = await fetch(
                `https://api.japaking.online/api/user-subscription`,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${authToken}`,
                    },
                }
            );

            if (!response.ok) {
                throw new Error("Failed to fetch user subscription data");
            }

            const data = await response.json();

            if (data && data.success) {
                const now = new Date();
                const activePlans = data.message.plan.filter(p => {
                    const activity = p.Activity_Status ? String(p.Activity_Status).toLowerCase() : "";
                    return activity === "active" || 
                           activity === "trial" || 
                           activity === "trail" || 
                           (new Date(p.start_date) <= now && new Date(p.end_date) >= now && p.status === "active");
                });

                if (activePlans.length > 0) {
                    const endDate = new Date(activePlans[0].end_date);
                    const today = new Date();
                    const timeDiff = endDate.getTime() - today.getTime();
                    const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));
                    setSubscriptionDaysLeft(daysDiff > 0 ? daysDiff : 0);
                } else {
                    setSubscriptionDaysLeft(0);
                }
                const hasActiveSubscription = activePlans.length > 0;

                if (hasActiveSubscription) {
                    localStorage.setItem("couponVerified", "true");
                } else {
                    localStorage.removeItem("couponVerified");
                }

                setHasSubscribed(hasActiveSubscription);
            } else {
                console.log("No valid data or success flag:", data);
                setHasSubscribed(false);
                localStorage.removeItem("couponVerified");
                setSubscriptionDaysLeft(0);
            }
        } catch (err) {
            console.error("Error in checkSubscription:", err);
        } finally {
            setIsLoading(false);
        }
    }, [authToken]);

    useEffect(() => {
        if (authToken) {
            checkSubscription();
        }
    }, [authToken, checkSubscription]);

    const sortedDays = learningnData
        ? learningnData.sort((a, b) => a.pono - b.pono)
        : [];

    const sortedDaysByNumber = sortedDays.sort((a, b) => {
        const dayA = parseInt(a.day_name.replace("Lesson", "").trim(), 10);
        const dayB = parseInt(b.day_name.replace("Lesson", "").trim(), 10);
        return dayA - dayB;
    });
    useEffect(() => {
        const savedActiveModuleId = localStorage.getItem("LearningJourneyActiveModuleId");
        if (!savedActiveModuleId) {
            return;
        }

        const parsedId = parseInt(savedActiveModuleId, 10);
        if (isNaN(parsedId)) {
            return;
        }

        setActiveItem(parsedId);

        // Scroll the saved module into view (centered) after DOM paints
        setTimeout(() => {
            const el = document.getElementById(`learning-module-${parsedId}`);
            if (el) {
                el.scrollIntoView({ behavior: "auto", block: "center" });
            }
        }, 0);
    }, [sortedDaysByNumber.length]);

    return (
        <div className="Profile_Design_Main_Div_11">
            <div className="header_inner">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <ArrowBackIosIcon
                                onClick={() => navigate('/')}
                                className="icon_1"
                            />
                            <h2>{Translate?.message?.data?.chooseLearningModule || localTranslations?.chooseLearningModule || "Choose Your Learning Module"}</h2>
                            <ChatBubbleOutlineIcon onClick={() => navigate('/chat-with-staff')} className="logo_1" style={{ cursor: 'pointer', color: '#ffc0cb' }} />
                        </div>
                    </div>
                </div>
            </div>

            {/* Attendance Summary Section */}
            

            <div className="learning-journey-container">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <Box sx={{ borderBottom: 1, borderColor: 'divider' }} className="custom-tabs-container">
                                <Tabs
                                    value={selectedExamId}
                                    onChange={handleExamTypeClick}
                                    aria-label="exam tabs"
                                    className="level_tabs"
                                >
                                    {exams.map((exam) => (
                                        <Tab
                                            key={exam.exam_id}
                                            label={exam.exam_type}
                                            value={exam.exam_id}
                                            className={`custom-tab custom-tab_2 ${selectedExamId === exam.exam_id ? "selected_tab_1" : ""}`}
                                        />
                                    ))}
                                </Tabs>
                            </Box>
                        </div>
                    </div>
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <h6>
                                    {Translate?.message?.data?.subscribtion || localTranslations?.subscribtion || "Days Left"}: {subscriptionDaysLeft}
                                </h6>
                            </div>
                        </div>
                    </div>
                </div>

                {isLoading ? (
                    <div className="loading-container">
                        <p>Loading...</p>
                    </div>
                ) : (
                    <CustomTabPanel value={selectedExamId} index={selectedExamId}>
                        <div className="container">
                            {hasSubscribed ? (
                                <div className="row">
                                    {sortedDaysByNumber.map((module, moduleIndex) => (
                                      <div className="col-6 col-sm-4 col-md-3 col-lg-3 custom-module-col" key={moduleIndex}>


                                            <div
                                                id={`learning-module-${module.id}`}
                                                onClick={() =>
                                                    handleCardPress(module.id, module.day_name, module.pono)
                                                }
                                                className={`module-card22 ${couponVerified || moduleIndex === 0 || moduleIndex === 1
                                                    ? "white-background"
                                                    : ""
                                                    } ${activeItem === module.id ? "module-card-active" : ""}`}
                                                style={{ position: "relative" }}
                                            >
                                                <img
                                                    src={isLoadingImage ? `${process.env.PUBLIC_URL}/assets/images/loading.png` : module.image_url}
                                                    onLoad={() => setIsLoadingImage(false)}
                                                    onError={() => setIsLoadingImage(false)}
                                                    alt={module.day_name}
                                                    className="module-image"
                                                />
                                                <h6>{module.day_name}</h6>
                                                <p>{module?.desc}</p>
                                                {moduleIndex === 0 && (
                                                    <p className="module-description"></p>
                                                )}
                                                {marker?.includes(module.id) && (
                                                    <div
                                                        style={{
                                                            position: 'absolute',
                                                            top: 0,
                                                            right: 0,
                                                            width: '100%',
                                                            left: 0,
                                                            justifyContent: 'space-between',
                                                            alignItems: 'center',
                                                            flexDirection: 'row',
                                                            padding: "5px 15px",
                                                            display: "inline-flex",
                                                        }}
                                                    >
                                                        <FaTag color="#ffc0cb" size={20} />
                                                        <p
                                                            className="learned-text"
                                                            style={{
                                                                color: '#ffc0cb',
                                                                fontWeight: '600',
                                                                textAlign: 'left'
                                                            }}
                                                        >
                                                            {Translate?.message?.data?.Learned || localTranslations?.Learned || "Learned"}
                                                        </p>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <div className="row">
                                    {sortedDaysByNumber.map((module, index) => (
                                        <div className="col-6 col-sm-4 col-md-3 col-lg-3" key={index}>
                                            <div
                                                id={`learning-module-${module.id}`}
                                                onClick={() =>
                                                    handleCardPress(module.id, module.day_name, module.pono)
                                                }
                                                className={`module-card ${couponVerified || module.day_name === 'पाठ 0' || module.day_name === 'Lesson 0' || module.day_name === 'पाठ 1' || module.day_name === 'Lesson 1' ? "white-background" : ""
                                                    } ${activeItem === module.id ? "module-card-active" : ""}`}
                                            >
                                                <img
                                                    src={isLoadingImage ? `${process.env.PUBLIC_URL}/assets/images/loading.png` : module.image_url}
                                                    onLoad={() => setIsLoadingImage(false)}
                                                    onError={() => setIsLoadingImage(false)}
                                                    className="module-image"
                                                    alt={module.day_name}
                                                />
                                                <h6>{module.day_name}</h6>
                                                <p>{module?.desc}</p>
                                                {index === 0 && <p className="module-description"></p>}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </CustomTabPanel>
                )}
            </div>
            <FooterNav authToken={authToken} translate={Translate} />
            {!couponVerified && isModalOpen && (
                <div className="modal-overlay">
                    <div className="modal-content">
                        <span onClick={closeModal} className="close-icon">×</span>
                        <img
                            src={`${process.env.PUBLIC_URL}/assets/images/learning4.jpg`}
                            className="modal-image"
                        />
                        <button className="pay-now-btn" onClick={() => navigate(window.ReactNativeWebView ? "/AppView" : "/plans")}>
                            Pay Now
                        </button>
                        <div className="line-with-text">Apply Coupon</div>
                        <button className="coupon-code-btn" onClick={openCouponModal}>
                            Coupon Code
                        </button>
                    </div>
                </div>
            )}
            {isCouponModalOpen && (
                <div className="modal-overlay">
                    <div className="modal-content">
                        <span onClick={closeModal} className="close-icon">×</span>
                        <h5>Details</h5>
                        <label>Universities:</label>
                        <select
                            className="dropdown"
                            value={selectedUniversity}
                            onChange={(e) => setSelectedUniversity(e.target.value)}
                        >
                            <option value="">Select University</option>
                            {Universitydata.map((item, index) => (
                                <option key={index} value={item.value}>
                                    {item.label}
                                </option>
                            ))}
                        </select>
                        <label>Level:</label>
                        <select
                            className="dropdown"
                            value={selectedLevel}
                            onChange={(e) => setSelectedLevel(e.target.value)}
                        >
                            <option value="">Select Level</option>
                            {Leveldata.map((item, index) => (
                                <option key={index} value={item.value}>
                                    {item.label}
                                </option>
                            ))}
                        </select>
                        <label>Coupon Code:</label>
                        <input
                            type="text"
                            className="coupon-code-input"
                            placeholder="Enter coupon code"
                            value={couponCode}
                            onChange={(e) => setCouponCode(e.target.value)}
                        />
                        <button className="submit-btn" onClick={verifyCoupon}>
                            Submit
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}

export default LearningJourney;
